import useIsMobile from '@/hooks/useIsMobile';
import NotificationSettingsDesktop from './desktop';
import NotificationSettingsMobile from './mobile';
import useNotificationSettings from './useNotificationSettings';

const NotificationSettingsPage = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useNotificationSettings();

  if (isMobile) {
    return <NotificationSettingsMobile viewModel={viewModel} />;
  }

  return <NotificationSettingsDesktop viewModel={viewModel} />;
};

export default NotificationSettingsPage;
